var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('CatchphraseSection'),_c('FundingStructureSection'),_c('EarningsRateChartSection'),_c('BusinessSecretSection'),_c('VideoSection'),_c('MediaSection'),_c('InterviewSection'),_c('AffiliateSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }